//Using the react library
import React from "react";
import data from '../data/data.json'
import { useState } from "react";

function DDIDCountyList() {

    const [selected, setSelected] = useState (null);  
    
    // useEffect(() => {

    //     const fetchLinks = async () => {
    //         const [data, status] = await getRequest(null, "crisisnos");
    //         if (status == 200) {
    //             setContent(data.data)
    //         }
    //         else {
    //             console.log(error)
    //         }
    //     };
    //     fetchLinks();
    // }, []);

    return (

        <>
            <div title="County List" className="col-md-4 col-md-3">          
                    {/* Return List */}
                    <select className="form-select" onChange={(e) => {
                        // console.log(e.target.value);
                        const c = data.ddidCountyListContacts?.find((x) => x.county === e.target.value)
                        setSelected(c) 
                        // console.log(selected)  
                    }}>
                        <option>Select a County</option>
                        {/* {                           
                             data.ddidCountyListContacts.map((data, index) => {
                                
                                return (
                                    <option key={index} value={data.county} className="form-select"        

                                    >{data.county}</option>
                                )
                            })
                        } */}
                        <option value="Adanta" className="form-select">Adair</option>
                        <option value="LifeSkills" className="form-select">Allen</option>
                        <option value="New Vista" className="form-select">Anderson</option>
                        <option value="Four Rivers" className="form-select">Ballard</option>
                        <option value="LifeSkills" className="form-select">Barren</option>
                        <option value="Pathways" className="form-select">Bath</option>
                        <option value="Cumberland River Comprehensive Care (CRCC)" className="form-select">Bell</option>
                        <option value="North Key" className="form-select">Boone</option>
                        <option value="New Vista" className="form-select">Bourbon</option>
                        <option value="Pathways" className="form-select">Boyd</option>
                        <option value="New Vista" className="form-select">Boyle</option>
                        <option value="Comprehend" className="form-select">Bracken</option>
                        <option value="Kentucky River Community Care (KRCC)" className="form-select">Breathitt</option>
                        <option value="Communicare" className="form-select">Breckinridge</option>
                        <option value="Seven Counties" className="form-select">Bullitt</option>
                        <option value="LifeSkills" className="form-select">Butler</option>
                        <option value="Pennyroyal" className="form-select">Caldwell</option>
                        <option value="Four Rivers" className="form-select">Calloway</option>
                        <option value="North Key" className="form-select">Campbell</option>
                        <option value="Four Rivers" className="form-select">Carlisle</option>
                        <option value="North Key" className="form-select">Carroll</option>
                        <option value="Pathways" className="form-select">Carter</option>
                        <option value="Adanta" className="form-select">Casey</option>
                        <option value="Pennyroyal" className="form-select">Christian</option>
                        <option value="New Vista" className="form-select">Clark</option>
                        <option value="Cumberland River Comprehensive Care (CRCC)" className="form-select">Clay</option>
                        <option value="Adanta" className="form-select">Clinton</option>
                        <option value="Pennyroyal" className="form-select">Crittenden</option>
                        <option value="Adanta" className="form-select">Cumberland</option>
                        <option value="River Valley" className="form-select">Daviess</option>
                        <option value="LifeSkills" className="form-select">Edmonson</option>
                        <option value="Pathways" className="form-select">Elliott</option>
                        <option value="New Vista" className="form-select">Estill</option>
                        <option value="New Vista" className="form-select">Fayette</option>
                        <option value="Comprehend" className="form-select">Fleming</option>
                        <option value="Mountain Comprehensive Care" className="form-select">Floyd</option>
                        <option value="New Vista" className="form-select">Franklin</option>
                        <option value="North Key" className="form-select">Gallatin</option>
                        <option value="New Vista" className="form-select">Garrard</option>
                        <option value="North Key" className="form-select">Grant</option>
                        <option value="Four Rivers" className="form-select">Graves</option>
                        <option value="Communicare" className="form-select">Grayson</option>
                        <option value="Adanta" className="form-select">Green</option>
                        <option value="Pathways" className="form-select">Greenup</option>
                        <option value="River Valley" className="form-select">Hancock</option>
                        <option value="Communicare" className="form-select">Hardin</option>
                        <option value="Cumberland River Comprehensive Care (CRCC)" className="form-select">Harlan</option>
                        <option value="New Vista" className="form-select">Harrison</option>
                        <option value="LifeSkills" className="form-select">Hart</option>
                        <option value="River Valley" className="form-select">Henderson</option>
                        <option value="Seven Counties" className="form-select">Henry</option>
                        <option value="Four Rivers" className="form-select">Hickman</option>
                        <option value="Pennyroyal" className="form-select">Hopkins</option>
                        <option value="Cumberland River Comprehensive Care (CRCC)" className="form-select">Jackson</option>
                        <option value="Seven Counties" className="form-select">Jefferson</option>
                        <option value="New Vista" className="form-select">Jessamine</option>
                        <option value="Mountain Comprehensive Care" className="form-select">Johnson</option>
                        <option value="North Key" className="form-select">Kenton</option>
                        <option value="Kentucky River Community Care (KRCC)" className="form-select">Knott</option>
                        <option value="Cumberland River Comprehensive Care (CRCC)" className="form-select">Knox</option>
                        <option value="Communicare" className="form-select">Larue</option>
                        <option value="Cumberland River Comprehensive Care (CRCC)" className="form-select">Laurel</option>
                        <option value="Pathways" className="form-select">Lawrence</option>
                        <option value="Kentucky River Community Care (KRCC)" className="form-select">Lee</option>
                        <option value="Kentucky River Community Care (KRCC)" className="form-select">Leslie</option>
                        <option value="Kentucky River Community Care (KRCC)" className="form-select">Letcher</option>
                        <option value="Comprehend" className="form-select">Lewis</option>
                        <option value="New Vista" className="form-select">Lincoln</option>
                        <option value="Four Rivers" className="form-select">Livingston</option>
                        <option value="LifeSkills" className="form-select">Logan</option>
                        <option value="Pennyroyal" className="form-select">Lyon</option>
                        <option value="New Vista" className="form-select">Madison</option>
                        <option value="Mountain Comprehensive Care" className="form-select">Magoffin</option>
                        <option value="Communicare" className="form-select">Marion</option>
                        <option value="Four Rivers" className="form-select">Marshall</option>
                        <option value="Mountain Comprehensive Care" className="form-select">Martin</option>
                        <option value="Comprehend" className="form-select">Mason</option>
                        <option value="Four Rivers" className="form-select">McCracken</option>
                        <option value="Adanta" className="form-select">McCreary</option>
                        <option value="River Valley" className="form-select">McLean</option>
                        <option value="Communicare" className="form-select">Meade</option>
                        <option value="Pathways" className="form-select">Menifee</option>
                        <option value="New Vista" className="form-select">Mercer</option>
                        <option value="LifeSkills" className="form-select">Metcalfe</option>
                        <option value="LifeSkills" className="form-select">Monroe</option>
                        <option value="Pathways" className="form-select">Montgomery</option>
                        <option value="Pathways" className="form-select">Morgan</option>
                        <option value="Pennyroyal" className="form-select">Muhlenberg</option>
                        <option value="Communicare" className="form-select">Nelson</option>
                        <option value="New Vista" className="form-select">Nicholas</option>
                        <option value="River Valley" className="form-select">Ohio</option>
                        <option value="Seven Counties" className="form-select">Oldham</option>
                        <option value="North Key" className="form-select">Owen</option>
                        <option value="Kentucky River Community Care (KRCC)" className="form-select">Owsley</option>
                        <option value="North Key" className="form-select">Pendleton</option>
                        <option value="Kentucky River Community Care (KRCC)" className="form-select">Perry</option>
                        <option value="Mountain Comprehensive Care" className="form-select">Pike</option>
                        <option value="New Vista" className="form-select">Powell</option>
                        <option value="Adanta" className="form-select">Pulaski</option>
                        <option value="Comprehend" className="form-select">Robertson</option>
                        <option value="Cumberland River Comprehensive Care (CRCC)" className="form-select">Rockcastle</option>
                        <option value="Pathways" className="form-select">Rowan</option>
                        <option value="Adanta" className="form-select">Russell</option>
                        <option value="New Vista" className="form-select">Scott</option>
                        <option value="Seven Counties" className="form-select">Shelby</option>
                        <option value="LifeSkills" className="form-select">Simpson</option>
                        <option value="Seven Counties" className="form-select">Spencer</option>
                        <option value="Adanta" className="form-select">Taylor</option>
                        <option value="Pennyroyal" className="form-select">Todd</option>
                        <option value="Pennyroyal" className="form-select">Trigg</option>
                        <option value="Seven Counties" className="form-select">Trimble</option>
                        <option value="River Valley" className="form-select">Union</option>
                        <option value="LifeSkills" className="form-select">Warren</option>
                        <option value="Communicare" className="form-select">Washington</option>
                        <option value="Adanta" className="form-select">Wayne</option>
                        <option value="River Valley" className="form-select">Webster</option>
                        <option value="Cumberland River Comprehensive Care (CRCC)" className="form-select">Whitley</option>
                        <option value="Kentucky River Community Care (KRCC)" className="form-select">Wolfe</option>
                        <option value="New Vista" className="form-select">Woodford</option>
                    </select>
              
            </div>
            {selected ? <>
            <br/>
           <b>Counties: </b> {selected.people}<br/>
            <b><u>{selected.county}:</u></b><br/>
            Contact Person: {selected.contact}<br/>
            Phone Number: {selected.number}<br/>    
            </>
            : null }
        </>

    );
}

export default DDIDCountyList;